import { render, staticRenderFns } from "./ReceiptProduct.vue?vue&type=template&id=524ffdba&scoped=true&"
import script from "./ReceiptProduct.vue?vue&type=script&lang=js&"
export * from "./ReceiptProduct.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptProduct.vue?vue&type=style&index=0&id=524ffdba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ffdba",
  null
  
)

export default component.exports